import React from 'react'
import { Fab, Tooltip } from '@mui/material'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import { advancedColors, onDark } from '../theme'

const DashboardCustomizeButton = ({ onOpen }: { onOpen: () => void }) => (
  <Tooltip title="Customize dashboard" placement="left">
    <Fab
      size="medium"
      aria-label="Open customize dashboard"
      onClick={onOpen}
      sx={{
        position: 'absolute',
        bottom: 24,
        right: 24,
        // Above the resize grips, which raise themselves to 2.
        zIndex: 3,
        backgroundColor: advancedColors.deep,
        color: onDark.primary,
        '&:hover': { backgroundColor: advancedColors.greenHover },
      }}
    >
      <TuneRoundedIcon />
    </Fab>
  </Tooltip>
)

export default DashboardCustomizeButton
